import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Navbar.styles.css";
import navLogo from "../../assets/images/nav-logo-1.jpg";
import BookDemoForm from "../BookDemoForm/BookDemoForm";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [showFormModal, setShowFormModal] = useState(false);

  const handleFormToggle = () => {
    setMenuOpen(false);
    setShowFormModal(!showFormModal);
  };

  const handleLinkClick = () => {
    setMenuOpen(false);
  };

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-white shadow-lg transition-all duration-300 ease-in-out">
      <nav className="py-3">
        <div className="container mx-auto flex justify-between items-center px-6">
          <Link to="/">
            <div className="flex items-center" onClick={handleLinkClick}>
              <img
                src={navLogo}
                alt="Smart Nexus Logo"
                className="h-7 w-7 mr-2 rounded-full filter contrast-125 "
              />

              <div className="text-2xl font-bold text-gray-900">Smart Nexus</div>
            </div>
          </Link>

          <button
            className="block md:hidden text-gray-900 focus:outline-none"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d={
                  menuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"
                }
              />
            </svg>
          </button>

          <ul className="hidden md:flex space-x-6 items-center px-6 font-semibold text-gray-900">
            <li>
              <Link to="/services" onClick={handleLinkClick}>
                Services
              </Link>
            </li>
            <li>
              <Link to="/products" onClick={handleLinkClick}>
                Products
              </Link>
            </li>
            <li>
              <Link to="/freeaudit" onClick={handleLinkClick}>
                Free AI Automation Audit!
              </Link>
            </li>
            <li>
              <Link to="/newsletter" onClick={handleLinkClick}>
                Newsletter
              </Link>
            </li>
          </ul>

          <div className="hidden md:block ml-auto">
            <button
              onClick={handleFormToggle}
              className="bg-blue-600 text-white py-2 px-4 rounded-full shadow-md hover:bg-blue-700 transition"
            >
              Book A Demo
            </button>
          </div>
        </div>

        {menuOpen && (
          <div className="md:hidden mt-4 px-6 text-gray-900">
            <ul className="space-y-4 font-semibold">
              <li>
                <Link to="/services" onClick={handleLinkClick}>
                  Services
                </Link>
              </li>
              <li>
                <Link to="/products" onClick={handleLinkClick}>
                  Products
                </Link>
              </li>
              <li className="blink" onClick={handleLinkClick}>
                <Link to="/freeaudit">Free AI Automation Audit!</Link>
              </li>
              <li className="blink" onClick={handleLinkClick}>
                <Link to="/newsletter">Newsletter</Link>
              </li>
            </ul>
            <div className="mt-4">
              <button
                onClick={handleFormToggle}
                className="bg-blue-600 text-white py-2 px-4 rounded-full shadow-md w-full hover:bg-blue-700 transition"
              >
                Book A Demo
              </button>
            </div>
          </div>
        )}
      </nav>

      {showFormModal && <BookDemoForm onClose={handleFormToggle} />}
    </div>
  );
};

export default Navbar;